module.exports = __webpack_public_path__ + "img/hc_pro_one_3.b430398b.jpg";